import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { PRICE } from '../data/content';
const recap = ['6 冊教材', '5 份附送', '240 頁', '小一至中三'];
const reassurances = ['即時下載', '工作紙可直接列印', '7 天滿意保證'];
export function FinalCta() {
  return <section className="relative w-full overflow-hidden bg-seyes px-8 py-24 sm:px-14 sm:py-32" data-id="element-114" data-mp="19cmcaewmxvf3">
      <div aria-hidden="true" className="pointer-events-none absolute inset-y-0 left-4 w-px bg-red-300 sm:left-8 lg:left-12" data-id="element-115" data-mp="15fq9gcpbzi8q" />
      <div className="relative mx-auto max-w-3xl text-center" data-id="element-116" data-mp="1eek1rqvmpmgh">
        <h2 className="font-serif text-[2.6rem] leading-[1.02] tracking-tight text-slate-900 sm:text-6xl" data-id="element-117" data-mp="1ebxttq4tt4xq">
          你的體育課，<em className="text-red-700" data-id="element-118" data-mp="1o3v7r4n7yb05">今天就可以準備好。</em>
        </h2>
        <p className="mx-auto mt-6 max-w-2xl text-lg leading-relaxed text-slate-900/75" data-id="element-119" data-mp="1o4dc6ok1bvj5">
          不用再找教案、自己設計每一個遊戲、把週末都花在備課上——你有一套整理好的全年體育教材。把時間留給真正重要的事：
        </p>
        <p className="mt-6 font-serif text-2xl italic leading-snug text-slate-900 sm:text-3xl" data-id="element-120" data-mp="1x5b7migequq4">
          你的學生。你的課堂。你在學校以外的生活。
        </p>

        <ul className="mt-10 flex flex-wrap justify-center gap-x-6 gap-y-2 text-sm font-medium text-slate-900/70" data-id="element-121" data-mp="n7fdpjpo0sax">
          {recap.map(item => <li key={item} data-id="element-122" data-mp="x41yy9lwlldh">{item}</li>)}
        </ul>

        <p className="mt-8 font-serif text-6xl leading-none tracking-tight text-slate-900 sm:text-7xl" data-id="element-123" data-mp="x27d8t2t5p8c">{PRICE}</p>
        <p className="mt-3 text-sm text-slate-900/70" data-id="element-124" data-mp="1246dvv75y81l">一次付款——無需訂閱。</p>

        <div className="mt-8 flex justify-center" data-id="element-125" data-mp="163p14xmgiv7l">
          <CtaButton className="w-full sm:w-auto" data-id="element-126" data-mp="1b3jsf2a59mt6" />
        </div>

        <ul className="mt-6 flex flex-wrap justify-center gap-x-6 gap-y-1.5 text-sm text-slate-900/70" data-id="element-127" data-mp="1b1qjfgc26qi0">
          {reassurances.map(item => <li key={item} className="flex items-center gap-2" data-id="element-128" data-mp="1ktd2fyun1tvb">
              <CheckIcon className="h-4 w-4 text-red-700" aria-hidden="true" data-id="element-129" data-mp="1ksth085s4ncj" />
              {item}
            </li>)}
        </ul>
      </div>
    </section>;
}